module.exports = __webpack_public_path__ + "static/img/technologicalProcess.17fafae4.png";